module.exports = __webpack_public_path__ + "img/login_logo.85c199ff.png";